import React, { useState } from "react";

import styled from "@emotion/styled";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ProductClickAndInfoType } from "@swo/storefront";

export const ProductClickAndInfoBackground = styled.div<{
  backgroundColor: ProductClickAndInfoType["backgroundColor"];
}>`
  background-color: ${props => (props.backgroundColor === "Light green" ? CSS_COLORS.GreenWhite : CSS_COLORS.White)};

  padding-bottom: 30px;
  ${CSS_MQ.atLeastMd} {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  --left: 2fr;
  --right: 3fr;

  ${CSS_MQ.atLeastXl} {
    --left: 3fr;
    --right: 5fr;
  }
`;
